// Constants
import {
    LOADING_STUDENT_NOTES,
    INITIALIZE_STUDENT_NOTES,
    RESET_STUDENT_NOTES,
} from "@/store/actions/notesActions";

const initialState = {
    loading: true,
    data: [],
};

const notesReducer = (state = initialState, action) => {
    if (action.type === INITIALIZE_STUDENT_NOTES) {
        return { ...state, data: action.payload, loading: false };
    } else if (action.type === LOADING_STUDENT_NOTES) {
        return { ...state, loading: action.payload };
    } else if (action.type === RESET_STUDENT_NOTES) {
        return { ...initialState };
    } else {
        return state;
    }
};

export default notesReducer;
